import { render } from "./ModalContent.vue?vue&type=template&id=3630c1f3"
import script from "./ModalContent.vue?vue&type=script&lang=js"
export * from "./ModalContent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ferha\\workspace\\calculus\\digyinfo-demo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__